<app-larged-tuile
  icon="fa-kit fa-picto-injection-ph"
  [title]="'P0003606.dashboard.ph' | translate"
  [buttons]="buttonMode"
  [status]="
    buttons[this.actionStack!.getValue('iphSEtatPompe')].title! | translate
  "
  [statusMode]="
    this.actionStack!.getValue('iphSAlarme') === 1
      ? 'alarm'
      : buttons[this.actionStack!.getValue('iphSEtatPompe')].status!
  "
  [selectItem]="this.actionStack!.getValue('iphCActivationRegulation')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionPh_Controle,
      'iphCActivationRegulation',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
